export default __webpack_public_path__ + "static/media/image.d596e24e.png";